import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "title" }
const _hoisted_2 = {
  key: 1,
  class: "title inner-title truncate",
  "data-test": "title"
}
const _hoisted_3 = {
  key: 2,
  class: "short-description truncate",
  "data-test": "short-description"
}
const _hoisted_4 = { class: "badge-wrapper" }
const _hoisted_5 = ["src"]

import { computed } from "vue";
import {
  IonCard,
  IonCardHeader,
  IonCardContent,
  IonBadge,
  IonIcon,
} from "@ionic/vue";
import { checkmarkCircleOutline } from "ionicons/icons";
import { SanityAssessment } from "@/store";

interface Props {
  assessment: SanityAssessment;
  thumbnail?: string;
  placeholderImg?: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'AssessmentCard',
  props: {
    assessment: {},
    thumbnail: {},
    placeholderImg: {}
  },
  setup(__props: any) {

const props = __props;

const getThumbnail = computed(() => {
  return props.thumbnail || props.placeholderImg;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonCard), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonCardHeader), null, {
        default: _withCtx(() => [
          (_ctx.assessment.isCompleted)
            ? (_openBlock(), _createBlock(_unref(IonBadge), {
                key: 0,
                class: "status-badge complete-label",
                "data-test": "completion-badge"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), {
                    icon: _unref(checkmarkCircleOutline),
                    "aria-hidden": "true"
                  }, null, 8, ["icon"]),
                  _createElementVNode("span", null, [
                    _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.$t("statusLabel.completed")), 1)
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.assessment.title)
            ? (_openBlock(), _createElementBlock("h3", _hoisted_2, _toDisplayString(_ctx.assessment.title), 1))
            : _createCommentVNode("", true),
          (_ctx.assessment.shortDescription)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.assessment.shortDescription), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(IonBadge), {
              color: "secondary",
              "data-test": "assessment-badge"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.assessment.badge), 1)
              ]),
              _: 1
            }),
            (_ctx.assessment.time)
              ? (_openBlock(), _createBlock(_unref(IonBadge), {
                  key: 0,
                  class: "time-badge",
                  "data-test": "time-badge"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.assessment.time + " " + _ctx.$t("assessment.mins")), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }),
      _createVNode(_unref(IonCardContent), null, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: getThumbnail.value,
            alt: "",
            "data-test": "thumbnail"
          }, null, 8, _hoisted_5)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})